<template>
  <div>
    <v-row v-if="!$vuetify.breakpoint.smAndUp">
      <v-spacer></v-spacer>
      <v-btn rounded class="mt-4 mx-6 primary text-none" @click="editLandlord">
        <v-icon left>
          mdi-pencil
        </v-icon>
        {{ $t("common.edit") }}
      </v-btn>
      <v-btn
        rounded
        class="mt-4 mr-4 primary text-none"
        @click="$router.push('/landlord')"
      >
        <v-icon left>
          mdi-arrow-left-circle-outline
        </v-icon>
        {{ $t("common.back") }}
      </v-btn>
    </v-row>
    <v-row>
      <v-card
        max-height="500"
        max-width="500"
        class="ma-5 custom-font"
        v-if="detailsCard"
      >
        <v-card-title>
          <v-row>
            <avatar
              v-if="landlorderDetails.avatar"
              class="mx-4"
              :size="80"
              :src="
                `${$store.getters.imageBaseUrl}/${landlorderDetails.avatar}`
              "
            />
            <div v-else-if="landlorderDetails.user">
              <avatar
                class="mx-4"
                :username="landlorderDetails.user.nameEn"
                :size="80"
              />
            </div>
            <div class="mx-5" v-if="landlorderDetails.user">
              <div class="d-flex justify-space-between align-center">
                <h3 class="primary--text pr-3">
                  {{
                    capitalizeFirstLetter(
                      `${landlorderDetails.user.nameEn} - ${landlorderDetails.user.nameAr}`
                    )
                  }}
                </h3>
                <!-- <VerifyLandlord
                  :status="!!landlorderDetails.destinationId"
                  :landlordUserId="landlorderDetails.user._id"
                  @verified="refetchLandlord"
                /> -->
              </div>
              <h6>
                <u>{{ landlorderDetails.companyName }}</u>
              </h6>
              <h6>{{ landlorderDetails.user.phone }}</h6>
              <h6>
                <u>{{ landlorderDetails.user.email }}</u>
              </h6>
            </div>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="5" class="py-1 font-weight-bold">{{
              $t("landlord.address")
            }}</v-col>

            <v-col cols="7" class="py-1 font-weight-medium">{{
              landlorderDetails.bio
            }}</v-col>

            <v-col cols="5" class="py-1 font-weight-bold">{{
              $t("landlord.civilIdNumber")
            }}</v-col>
            <v-col cols="7" class="py-1 font-weight-medium">
              {{ landlorderDetails.civilIdNumber }}
            </v-col>
            <v-col cols="5" class="py-1 font-weight-bold">{{
              $t("landlord.bankName")
            }}</v-col>
            <v-col cols="7" class="py-1 font-weight-medium">{{
              landlorderDetails.bankName
            }}</v-col>
            <v-col cols="5" class="py-1 font-weight-bold">{{
              $t("landlord.iban")
            }}</v-col>
            <v-col cols="7" class="py-1 font-weight-medium">{{
              landlorderDetails.IBAN
            }}</v-col>
            <!-- <v-col cols="5" class="py-1 font-weight-bold">{{
              $t("landlord.paymentType")
            }}</v-col>
            <v-col cols="7" class="py-1 font-weight-bold"
              ><v-chip
                v-for="item in landlorderDetails.paymentTypes"
                x-small
                class="green white--text mr-1"
                :key="item"
                >{{ item }}</v-chip
              ></v-col
            > -->
          </v-row>
        </v-card-text>
      </v-card>
      <v-spacer></v-spacer>
      <v-btn
        v-if="$vuetify.breakpoint.smAndUp"
        class="mt-4 mx-6 text-none rounded-lg white--text"
        color="primary"
        @click="editLandlord"
      >
        <v-icon size="20" left>
          mdi-pencil
        </v-icon>
        {{ $t("common.edit") }}
      </v-btn>
      <v-btn
        v-if="$vuetify.breakpoint.smAndUp"
        class="mt-4 mr-4 text-none rounded-lg white--text"
        color="primary"
        @click="$router.push('/landlord')"
      >
        <v-icon size="20" left>
          mdi-arrow-left-circle-outline
        </v-icon>
        {{ $t("common.back") }}
      </v-btn>
    </v-row>
    <template>
      <v-card class="mx-2 mb-4">
        <v-tabs v-model="tab" background-color="white">
          <v-tab v-for="item in tabItems" :key="item.tab">
            {{ item.tab }}
          </v-tab>
        </v-tabs>
        <v-divider></v-divider>
        <v-tabs-items v-model="tab">
          <v-tab-item v-for="item in tabItems" :key="item.tab">
            <v-card flat>
              <v-card-text v-if="item.content === 'PROPERTY'" class="pb-4">
                <!-- <v-row>
                  <v-col cols="12" class="text-end">
                    <v-btn
                      class="white--text"
                      color="primary"
                      @click="addOrEditProperty"
                      :class="
                        $vuetify.breakpoint.smAndUp
                          ? 'my-2 rounded-lg'
                          : 'my-2 mx-2'
                      "
                    >
                      {{ $t("landlord.addProperty") }}
                    </v-btn>
                  </v-col>
                </v-row> -->
                <v-data-table
                  mobile-breakpoint
                  :items="propertyDetails"
                  :loading="
                    $apollo.queries.getPropertyByLandlordForAdmin.loading
                  "
                  :search="''"
                  :options="options"
                  tab="property"
                  :headers="propertyHeaders"
                  item-key="_id"
                  show-expand
                  single-expand
                >
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length">
                      <UnitTable :propertyId="item._id" :key="item._id" />
                    </td>
                  </template>
                  <template v-slot:[`item._id`]="{ item }">
                    {{ propertyDetails.indexOf(item) + 1 }}
                  </template>
                  <template v-slot:[`item.helthHygeineEn`]="{ item }">
                    <span v-html="item.helthHygeineEn"></span>
                  </template>
                  <template v-slot:[`item.helthHygeineAr`]="{ item }">
                    <div v-html="item.helthHygeineAr"></div>
                  </template>
                  <template v-slot:[`item.policyEn`]="{ item }">
                    <span v-html="item.policiesEn"></span>
                  </template>
                  <template v-slot:[`item.policyAr`]="{ item }">
                    <span v-html="item.policiesAr"></span>
                  </template>
                  <template #item.isActive="{ item }">
                    <PropertyDisableDialog
                      isProperty
                      :id="item._id"
                      :status="item.isActive"
                      :disabled="false"
                    />
                  </template>
                  <template #item.edit="{ item }">
                    <v-btn
                      icon
                      @click="
                        addOrEditProperty({
                          isEdit: true,
                          propertyId: item._id
                        })
                      "
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>

              <v-card-text v-if="item.content === 'SUBSCRIPTIONS'" class="pt-0">
                <v-row>
                  <v-col cols="12" class="text-end">
                    <v-btn
                      class="white--text"
                      color="primary"
                      @click="addOrEditSubscription()"
                      :class="
                        $vuetify.breakpoint.smAndUp
                          ? 'my-2 rounded-lg'
                          : 'my-2 mx-2'
                      "
                    >
                      {{ $t("plans.addSubscription") }}
                    </v-btn>
                  </v-col>
                </v-row>
                <v-data-table
                  mobile-breakpoint
                  :items="subscriptionDetails"
                  :loading="
                    $apollo.queries.getLandlordSubscriptionByLandlordId.loading
                  "
                  :search="''"
                  :options="options"
                  tab="property"
                  :headers="subscriptionHeaders"
                  item-key="_id"
                >
                  <template v-slot:[`item._id`]="{ item }">
                    {{ subscriptionDetails.indexOf(item) + 1 }}
                  </template>
                  <template v-slot:[`item.startDate`]="{ item }">
                    <span v-if="item.startDate">
                      {{ dateFormat(item.startDate) }}
                    </span>
                    <span v-else> -- </span>
                  </template>

                  <template v-slot:[`item.endDate`]="{ item }">
                    <span v-if="item.endDate">
                      {{ dateFormat(item.endDate) }}
                    </span>
                    <span v-else> -- </span>
                  </template>
                  <template v-slot:[`item.amount`]="{ item }">
                    <span v-if="item.amount">
                      {{ formatAmount(item.amount) }}
                    </span>
                    <span v-else> -- </span>
                  </template>
                  <template v-slot:[`item.currentStatus`]="{ item }">
                    <span>
                      {{
                        item.currentStatus === "ADVANCED"
                          ? "PENDING"
                          : item.currentStatus === "EXPIRED"
                          ? "EXPIRED"
                          : item.currentStatus
                      }}
                    </span>
                  </template>
                  <template v-slot:[`item.validity`]="{ item }">
                    <span v-if="item.validity"> {{ item.validity }} Days </span>
                    <span v-else> -- </span>
                  </template>

                  <template #item.edit="{ item }">
                    <v-btn
                      icon
                      v-if="allowEdit(item)"
                      @click="
                        modifySubscription({
                          subscriptionId: item._id
                        })
                      "
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>

                <SubsciptionPayments />
              </v-card-text>

              <v-card-text v-if="item.content === 'PAYMENTS'">
                <data-table
                  :payload="paymentDetails"
                  :search="''"
                  :totalPayload="totalPayment"
                  :options="options"
                  tab="payments"
                  :headers="paymentHeaders"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </template>
    <side-drawer>
      <template slot="formDetails">
        <CreateAndEditProperty
          v-if="propertyCreateOrEditMode"
          @refetchProperties="refetchProperties"
          :key="editPropertyProps.propertyId"
          v-bind="{
            ...editPropertyProps,
            ...{ landlordId: landlorderDetails._id }
          }"
        />
        <CreateAndEditSubscription
          v-if="subscriptionCreateOrEditMode"
          @refetch="refetchSubscriptions"
          :key="editSubscriptionProps.subscriptionId"
          :landlordId="landlorderDetails._id"
          v-bind="editSubscriptionProps"
        />
        <ModifySubscription
          v-if="subscriptionModifyMode"
          @refetch="refetchSubscriptions"
          :key="editSubscriptionProps.subscriptionId"
          :landlordId="landlorderDetails._id"
          v-bind="editSubscriptionProps"
        />
        <AddUnit
          v-bind="editUnitProps"
          :key="formRerender"
          v-else-if="unitCreateMode"
        />
        <EditUnit
          v-else-if="unitEditMode"
          :key="editUnitProps.unitId"
          v-bind="editUnitProps"
        />
        <landlord-form v-else-if="landlordEditMode" />
      </template>
    </side-drawer>
  </div>
</template>

<script>
import avatar from "vue-avatar";
import moment from "moment";

export default {
  data() {
    return {
      tab: null,
      bookingDetails: [],
      propertyDetails: [],
      landlorderDetails: {},
      detailsCard: false,
      expanded: false,
      propertyFormRerender: 0,
      options: {
        itemsPerPage: 50,
        page: 1
      },
      totalBooking: 0,
      totalProperty: 0,
      totalPayment: 10,
      propertyCreateOrEditMode: false,
      subscriptionCreateOrEditMode: false,
      subscriptionModifyMode: false,
      landlordEditMode: false,
      editPropertyProps: {
        propertyId: null
      },
      editSubscriptionProps: {
        subscriptionId: null
      },
      formRerender: 0,
      unitCreateMode: false,
      unitEditMode: false,
      editUnitProps: {},
      paymentDetails: [],
      subscriptionDetails: []
    };
  },
  created() {
    this.$root.$on("refetchUnits", () => {
      this.formRerender += 1;
    });
    this.$root.$on("refreshProperty", () => {
      this.refetchProperties();
    });
    this.$root.$on("refetchLandlord", this.refetchLandlord);
  },
  mounted() {
    this.$root.$on("unitChange", ({ isEditUnit, unitId, propertyId }) => {
      this.propertyCreateOrEditMode = false;
      this.editUnitProps = {
        landlordId: this.landlorderDetails._id,
        totalNumberOfUnitsAllowed: this.landlorderDetails.validityPlan
          .numberOfUnits,
        propertyId: propertyId
      };
      if (isEditUnit) {
        this.editUnitProps = {
          ...this.editUnitProps,
          ...{ unitId: unitId }
        };
        this.unitEditMode = true;
        this.unitCreateMode = false;
      } else {
        this.editUnitProps = {
          ...this.editUnitProps
        };
        this.unitEditMode = false;
        this.unitCreateMode = true;
        this.formRerender = this.formRerender + 1;
      }
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    });
    this.$root.$on("seletedTab", (data, input) => {
      let api = null;
      switch (data) {
        case "subscriptions":
          api = "getLandlordSubscriptionByLandlordId";
          break;
        case "property":
          api = "getPropertyByLandlordForAdmin";
          break;
        case "payments":
          api = "getPaymentsOfLandlord";
          break;
      }
      this.$apollo.queries[api].refetch({
        input: input
      });
    });
  },
  computed: {
    tabItems() {
      return [
        // { tab: this.$t("layout.bookings"), content: "BOOKING" },
        { tab: this.$t("layout.properties"), content: "PROPERTY" },
        { tab: this.$t("layout.payments"), content: "PAYMENTS" },
        { tab: this.$t("layout.subscriptions"), content: "SUBSCRIPTIONS" }
      ];
    },
    paymentHeaders() {
      return [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "_id",
          width: 10
        },
        {
          text: this.$t("payments.customerName"),
          align: "left",
          sortable: false,
          value: "customer.nameEn"
        },
        {
          text: this.$t("core.amount"),
          align: "left",
          sortable: false,
          value: "amount"
        },
        {
          text: this.$t("payments.date"),
          align: "left",
          sortable: false,
          value: "paymentDate"
        },

        {
          text: this.$t("payments.paymentMethod"),
          align: "left",
          sortable: false,
          value: "paymentMethod"
        },
        {
          text: this.$t("bookings.status"),
          align: "left",
          sortable: false,
          value: "status"
        }
      ];
    },
    subscriptionHeaders() {
      return [
        {
          text: "#",
          align: "left",
          value: "_id",
          width: 10
        },
        {
          text: this.$t("plans.name"),
          align: "left",
          value: "landlordValidityPlan.planName",
          width: 150
        },
        {
          text: this.$t("plans.startDate"),
          align: "center",
          value: "startDate",
          width: 150
        },
        {
          text: this.$t("plans.endDate"),
          align: "left",
          value: "endDate",
          width: 150
        },
        {
          text: this.$t("core.amount"),
          align: "left",
          value: "amount",
          width: 150
        },
        {
          text: this.$t("landlord.status"),
          align: "left",
          value: "currentStatus",
          width: 150
        },
        {
          text: "Action",
          align: "left",
          sortable: false,
          value: "edit",
          width: 100
        }
      ];
    },
    propertyHeaders() {
      return [
        {
          text: "#",
          align: "left",
          sortable: false,
          value: "_id",
          width: 10
        },
        {
          text: `${this.$t("settings.area.name")} (${this.$t("common.en")})`,
          align: "left",
          sortable: false,
          value: "nameEn",
          width: 100
        },
        {
          text: `${this.$t("settings.area.name")} (${this.$t("common.ar")})`,
          align: "left",
          sortable: false,
          value: "nameAr",
          width: 100
        },
        {
          text: this.$t("property.property.propertyNumber"),
          align: "left",
          sortable: false,
          value: "propertyNumber",
          width: 50
        },
        {
          text: this.$t("landlord.isActive"),
          align: "center",
          sortable: false,
          value: "isActive",
          width: 100
        },
        {
          text: this.$t("landlord.propertyType"),
          align: "left",
          sortable: false,
          value: "propertyType.nameEn",
          width: 100
        }
      ];
    }
  },
  components: {
    avatar,

    "side-drawer": () => import("@/core/components/SideDrawer"),
    "landlord-form": () =>
      import("../components/rightSideDrawer/LandlordForm.vue"),
    "data-table": () => import("../components/TabDataTable.vue"),
    CreateAndEditProperty: () =>
      import("../components/rightSideDrawer/CreateAndEditProperty.vue"),
    UnitTable: () => import("@/landlord/components/UnitTable.vue"),
    PropertyDisableDialog: () =>
      import("@/landlord/components/DisableDialog.vue"),
    AddUnit: () => import("@/landlord/components/rightSideDrawer/AddUnit.vue"),
    EditUnit: () =>
      import("@/landlord/components/rightSideDrawer/EditUnit.vue"),
    CreateAndEditSubscription: () =>
      import("../components/rightSideDrawer/CreateAndEditSubscription.vue"),
    ModifySubscription: () =>
      import("../components/rightSideDrawer/ModifySubscription.vue"),
    SubsciptionPayments: () => import("../components/SubsciptionPayments.vue")
  },
  apollo: {
    getLandlordById() {
      return {
        query: require("@/landlord/api/queries/single_landlord_query.graphql"),
        variables: {
          id: this.$route.params.id
        },
        fetchPolicy: "no-cache",
        result({ data }) {
          this.landlorderDetails = data.getLandlordById;
          this.detailsCard = true;
        }
      };
    },
    getLandlordSubscriptionByLandlordId() {
      this.loading = true;
      return {
        query: require("@/subscriptions/api/queries/get_subscriptions_by_landlord.graphql"),
        variables: {
          id: this.$route.params.id
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
          this.subscriptionDetails = this.$format.cloneVariable(
            data.getLandlordSubscriptionByLandlordId
          );
          this.loading = loading;
        }
      };
    },
    getPropertyByLandlordForAdmin() {
      this.loading = true;
      return {
        query: require("@/landlord/api/queries/property_query.graphql"),
        fetchPolicy: "no-cache",
        variables: {
          input: {
            limit: 50,
            skip: 0
          },
          landlordId: this.$route.params.id
        },
        result({ data }) {
          // , loading, networkStatus, refetch
          this.propertyDetails = this.$format.cloneVariable(
            data.getPropertyByLandlordForAdmin.properties
          );
          this.loading = false;
          this.totalProperty = data.getPropertyByLandlordForAdmin.totalCount;
        }
      };
    },
    getPaymentsOfLandlord() {
      this.loading = true;
      return {
        query: require("@/landlord/api/queries/payment_by_landlord.graphql"),
        variables: {
          input: {
            limit: 50,
            skip: 0
          },
          landlordId: this.$route.params.id
        },
        result({ data }) {
          if (data.getPaymentsOfLandlord) {
            this.paymentDetails = this.$format.cloneVariable(
              data.getPaymentsOfLandlord.paymentdetails
            );
            this.loading = false;
            this.totalPayment = data.getPaymentsOfLandlord.totalCount;
          }
        }
      };
    }
  },
  watch: {
    tab(newVal) {
      if (newVal === 2) {
        // Subscriptions tab index
        this.$apollo.queries.getLandlordSubscriptionByLandlordId.refetch();
      }
    }
  },
  methods: {
    refetchLandlord() {
      this.$apollo.queries.getLandlordById.refetch();
    },
    refetchProperties() {
      this.$apollo.queries.getPropertyByLandlordForAdmin.refetch({
        input: {
          limit: 50,
          skip: 0
        },
        landlordId: this.$route.params.id
      });
    },
    addOrEditProperty({ isEdit, propertyId }) {
      if (isEdit) {
        this.editPropertyProps = {
          propertyId: propertyId,
          isEdit: true
        };
      } else {
        this.editPropertyProps = {};
      }
      this.landlordEditMode = false;
      this.subscriptionCreateOrEditMode = false;
      this.subscriptionModifyMode = false;
      this.propertyCreateOrEditMode = true;
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    },
    editLandlord() {
      this.subscriptionModifyMode = false;
      this.subscriptionCreateOrEditMode = false;
      this.propertyCreateOrEditMode = false;
      this.landlordEditMode = true;
      setTimeout(() => {
        this.$store.commit("IS_EDIT_LANDLORD", true);
        this.$store.commit("EDIT_LANDLORD", this.landlorderDetails);
        this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
      }, 100);
    },
    dateFormat(date) {
      const rawDate = new Date(parseInt(date));
      return moment(rawDate, "YYYY-MM-DD").format("DD-MM-YYYY");
    },
    formatAmount(amount) {
      if (amount) {
        return parseFloat(amount).toFixed(3);
      }
      return "";
    },
    isExpired(endDate) {
      if (!endDate) return false;
      const today = moment().startOf("day");
      const end = moment(parseInt(endDate)).startOf("day");
      return end.isBefore(today);
    },
    allowEdit(item) {
      if (item.currentStatus == "ACTIVE") {
        return true;
      }
      return false;
    },
    addOrEditSubscription() {
      this.propertyCreateOrEditMode = false;
      this.landlordEditMode = false;
      this.subscriptionCreateOrEditMode = true;
      this.subscriptionModifyMode = false;
      this.editSubscriptionProps = {};
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    },
    modifySubscription({ subscriptionId }) {
      this.propertyCreateOrEditMode = false;
      this.landlordEditMode = false;
      this.subscriptionCreateOrEditMode = false;
      this.subscriptionModifyMode = true;
      this.editSubscriptionProps = {
        subscriptionId,
        isEdit: true
      };
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    },
    refetchSubscriptions() {
      this.$apollo.queries.getLandlordSubscriptionByLandlordId.refetch();
    }
  },
  beforeDestroy() {
    this.$root.$off("seletedTab");
    this.$root.$off("refetchLandlord");
  }
};
</script>

<style></style>
